module.exports = __webpack_public_path__ + "img/19.82b21e5d.jpg";